export default __webpack_public_path__ + "static/m-customer8-cf7068f76b7052f792049af82a9121b4.png";